<template>
  <div>
    <div v-if="!notAvailable" class="flex flex-col items-center lg:items-start bg-white
    rounded-4xl sm:rounded-20px py-20 px-40 lg:px-20 lg:py-10 sm:px-5  md:px-10 sm:py-20">
      <h1
        v-if="!sended"
        class="w-full text-44px font-bold text-neutral-50 sm:hidden mb-10"
      >
        {{ $t('security.security-questionnaire') }}
      </h1>
      <div v-if="fields && !sended" class="w-2/3 xl:w-full flex flex-col space-y-8 ">
        <div v-for="v in $v.fields.$each.$iter" :key="v.$model.field.id" class="relative">
          <div v-if="v.$model.field.type === 'TEXT' && v.$model.field.name.toLowerCase() !== 'отчество'">
            <FormInput
              v-model="v.value.$model"
              :placeholder="v.$model.field.description"
              :invalid="v.value.$error"
              :is-static="!v.$model.field.canModified"
              @blur="checkData(v)"
            >
              <template #label>
                <div class="pl-5 w-full">{{v.$model.field.description}}{{v.$model.field.required ? '*' : ''}}</div>
              </template>
            </FormInput>
            <span v-if="!v.value.maxLength255" class="text-danger-50 text-xs pl-5">
              {{ $t('security.field-too-long') }}
            </span>
          </div>
          <div
            v-if="v.$model.field.type === 'TEXT' && v.$model.field.name.toLowerCase() === 'отчество'"
            class="relative w-full mb-4"
          >
            <FormInput
              v-model="v.value.$model"
              :placeholder="v.$model.field.description"
              :invalid="v.value.$error"
              :is-static="!v.$model.field.canModified"
              @blur="checkData(v)"
            >
              <template #label>
                <div class="pl-5 w-full">{{v.$model.field.description}}{{v.$model.field.required ? '*' : ''}}</div>
              </template>
            </FormInput>
            <span v-if="!v.value.maxLength255" class="text-danger-50 text-xs pl-5">
              {{ $t('security.field-too-long') }}
            </span>
            <span class="text-neutral-120 text-xs absolute left-5 -bottom-5">
            {{ $t('security.if-you-donot-have-patranomic') }}
          </span>
          </div>
          <FormInputDate
            v-if="v.$model.field.type === 'DATE'"
            :value="formCurrentDate(v.value.$model, v.$model.field.name === 'Дата рождения')"
            class="date-picker"
            :placeholder="v.$model.field.description"
            :invalid="v.value.$error"
            :disabled="!v.$model.field.canModified"
            @input="v.value.$model = $event"
            @blur="checkData(v)"
          >
            <template #label>
              <div class="pl-5 w-full">{{v.$model.field.description}}{{v.$model.field.required ? '*' : ''}}</div>
            </template>
          </FormInputDate>
          <FormSelect
            v-if="['SINGLE'].includes(v.$model.field.type)"
            v-model="v.value.$model"
            :options="v.$model.field.options"
            :placeholder="v.$model.field.description"
            :invalid="v.value.$error"
            :disabled="!v.$model.field.canModified"
            searchable
            @search-blur="checkData(v)"
          >
            <template #label>
              <div class="pl-5 w-full">{{v.$model.field.description}}{{v.$model.field.required ? '*' : ''}}</div>
            </template>
          </FormSelect>
          <FormSelect
            v-if="['MULTIPLE'].includes(v.$model.field.type)"
            v-model="v.values.$model"
            :options="v.$model.field.options"
            :placeholder="v.$model.field.description"
            :invalid="v.values.$error"
            :multiple="v.$model.field.type === 'MULTIPLE'"
            :disabled="!v.$model.field.canModified"
            searchable
            @search-blur="checkData(v)"
          >
            <template #label>
              <div class="pl-5 w-full">{{v.$model.field.description}}{{v.$model.field.required ? '*' : ''}}</div>
            </template>
          </FormSelect>
          <FormSelect
            v-if="v.$model.field.type === 'NATIONALITY'"
            v-model="v.value.$model"
            :options="nationalityOptions"
            :invalid="v.value.$error"
            :placeholder="`${$t('security.citizenship')}`"
            :disabled="!v.$model.field.canModified"
            searchable
            @search-blur="checkData(v)"
          >
            <template #label>
              <div class="pl-5 w-full">{{$t('security.citizenship')}}{{v.$model.field.required ? '*' : ''}}</div>
            </template>
          </FormSelect>
          <FormInput
            v-if="v.$model.field.type === 'EMAIL'"
            v-model="v.value.$model"
            :invalid="v.value.$error"
            :is-static="!v.$model.field.canModified"
            :placeholder="$t('landing.email')"
            @blur="checkData(v)"
          >
            <template #label>
              <div class="pl-5 w-full">
                {{ $t('landing.email') }}{{v.$model.field.required ? '*' : ''}}
              </div>
            </template>
          </FormInput>
          <FormInput
            v-if="v.$model.field.type === 'PHONE'"
            v-model="v.value.$model"
            :invalid="v.value.$error"
            :is-static="!v.$model.field.canModified"
            :mask="getPhoneMask"
            :placeholder="`${$t('landing.phone-number')}`"
            @blur="checkData(v)"
          >
            <template #label>
              <div class="pl-5 w-full">{{ $t('landing.phone-number') }}{{v.$model.field.required ? '*' : ''}}</div>
            </template>
          </FormInput>
          <div v-if="v.$model.field.type === 'FILE'">
            <FormFile
              v-model="v.value.$model"
              :disabled="getCurrentReference(v.$model.field.id).length === 2"
              :error="fileUploadError"
              :title-text="v.$model.field.description"
              type="reference"
              :accept="referenceTypes"
              @input="fileInputHandler($event, v.$model.field.id)"
            />
            <div v-if="reference && reference.length" class="flex items-center pt-3 pl-8 w-full">
              <template v-for="(item, index) in reference">
                <div
                  v-if="item.fieldId === v.$model.field.id"
                  :key="index"
                  class="
                rounded-md border-neutral-400 border py-2.5 px-3 flex items-center cursor-pointer max-w-50 mr-2
              "
                  @click="showReference(item)"
                >
              <span class="text-primary-200 font-medium pr-2 truncate">
                {{ item.file.name }}
              </span>
                  <img
                    src="@/assets/icons/cancel.svg"
                    alt=""
                    class="cursor-pointer"
                    @click="removeFile($event, item.fileId)"
                  />
                </div>
              </template>
            </div>
          </div>
        </div>
        <Button :disabled="isLoading" @click="onSend">{{ $t('landing.send-questionnaire') }}</Button>
      </div>
      <div v-if="sended" class="w-2/3 xl:w-full flex flex-col items-center space-y-5">
        <img src="@/assets/icons/ok-icon.svg" alt="ok">
        <h1 class="text-32px font-bold">{{ $t('landing.questionnaire-sent-successfully') }}</h1>
        <p
          class="last-screen-text"
          v-html="$t('security.email-results', { userEmail: application.candidate.email })"
        ></p>
      </div>
      <ModalWindow
        v-model="showAgreementModal"
      >
        <template #default="{closeModal}">
          <div class="text-center font-bold mb-2">
            {{ $t('common.accept-agreement-to-continue') }}
          </div>

          <div class="flex justify-center mb-4">
            <FormCheckbox v-model="isAgreementAccepted">
              <span class="text-sm text-neutral-50">
                <a
                  v-if="$domain === 'ru'"
                  class="text-blue-600"
                  :href="`/${$t('common.pd-processing-policy-file-name')}`"
                  target="_blank"
                >
                  {{ $t('common.i-accept-user-data-proccesing') }}
                </a>
                <a
                  v-else-if="$route.query.language === 'ru'"
                  class="text-blue-600"
                  :href="`/${$t(pdProcessingPolicyFile)}`"
                  target="_blank"
                >
                  {{ $t('common.i-accept-user-data-proccesing') }}
                </a>
                <a
                  v-else
                  class="text-blue-600"
                  :href="`/${$t('common.pd-processing-policy-file-name')}`"
                  target="_blank"
                >
                  {{ $t('common.i-accept-user-data-proccesing') }}
                </a>
              </span>
            </FormCheckbox>
          </div>

          <div class="flex justify-center">
            <Button
              class="px-12 rounded-sm"
              size="small"
              :rounded="false"
              :disabled="!isAgreementAccepted"
              @click="confirmAgreement(closeModal)"
            >
              {{ $t('common.continue') }}
            </Button>
          </div>
        </template>
      </ModalWindow>
    </div>
    <div v-else class="flex flex-col items-center lg:items-start bg-white
    rounded-4xl sm:rounded-20px py-20 px-40 lg:px-20 lg:py-10 sm:px-5 md:px-10 sm:py-20 error-page">
      <h1 class="w-full font-bold text-neutral-50">
        {{ $t('security.security-questionnaire') }}
      </h1>
      <h3 class="font-semibold mx-auto">
        Вы уже заполнили анкету. <br> Обратитесь к директору магазина.
      </h3>
    </div>
    <Loading v-if="isLoading" />
  </div>
</template>
<script>
import {
  email, required, maxLength,
} from 'vuelidate/lib/validators';
import { i18n } from '@/i18n';
import {
  getCountries,
  getWorkSchedules,
  getSecurityData,
  postSecurityData,
  checkCandidateAgreement,
  confirmAgreementRequest,
  postReference,
  removeReference,
} from '@/api';
import toast from '@/notify';
import sanitize from '@/sanitize';
import phoneMaskMixin from '@/mixins/phoneMaskMixin';
import { phoneValidator } from '@/helpers/validation';

import FormInput from '@/components/Form/FormInput.vue';
import FormSelect from '@/components/Form/FormSelect.vue';
import FormInputDate from '@/components/Form/FormInputDate.vue';
import Button from '@/components/UI/Button.vue';
import ModalWindow from '../UI/ModalWindow.vue';
import FormCheckbox from '../Form/FormCheckbox.vue';
import FormFile from '@/components/Form/FormFile.vue';
import { showFile } from '@/helpers/file';
import Loading from '@/components/UI/Loading.vue';

const segmentsRequiringAgreementConfirmation = [
  'SPORTMASTER_KZ', 'SPORTMASTER_UZ', 'SPORTMASTER_BY', 'SPORTMASTER_AM', 'SPORTMASTER_KG',
];

export default {
  name: 'MainContent',
  components: {
    Loading,
    FormInput,
    FormSelect,
    FormInputDate,
    Button,
    ModalWindow,
    FormCheckbox,
    FormFile,
  },
  mixins: [phoneMaskMixin],
  data() {
    return {
      i18n,
      segmentsRequiringAgreementConfirmation,
      isAgreementAccepted: false,
      showAgreementModal: false,
      securityProfile: {
        person: '',
        nationality: '',
        birthday: null,
        phone: '',
        position: this.$t('security.store-manager'),
        office: 'Рязанский пр., 2к2',
        serialNumber: '',
        issueDate: null,
        pasportDepartment: '',
      },
      inputState: {
        person: 'blur',
      },
      placeholders: {
        person: {
          focus: this.$t('landing.full-name-exemplicant'),
          blur: `${this.$t('landing.type-full-name')}*`,
        },
      },
      nationalityData: [],
      schedulesData: [],
      application: null,
      fields: null,
      templateData: null,
      templateRevision: null,
      sended: false,
      notAvailable: false,
      reference: [],
      referenceTypes: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
      fileUploadError: false,
      isLoading: false,
    };
  },
  async mounted() {
    const queue1 = [
      getCountries(),
      getWorkSchedules(),
    ];

    const setDataMap = new Map([
      ['/countries', 'nationalityData'],
      ['/regions', 'regionsData'],
      ['/offices-candidate', 'officesData'],
      ['/vacancies-candidate/positions', 'vacanciesData'],
      ['/work-schedules', 'schedulesData'],
    ]);

    Promise.all(queue1).then((response) => {
      Array.from(response).forEach(({ config, data }) => {
        this[setDataMap.get(config.url)] = data;
      });
    });

    const { id } = this.$route.params;
    const response = await getSecurityData(id);
    const { status, data } = response;

    if (status === 200) {
      const {
        application, fields, template, templateRevision,
      } = data;
      this.application = application;
      this.fields = fields;
      this.templateData = template;
      this.templateRevision = templateRevision;
    } else if (status === 404) {
      toast.danger({
        title: data.error.description,
      });
    } else if ([401, 403].includes(status)) {
      this.notAvailable = true;
    }
  },
  validations: {
    fields: {
      $each: {
        value: {
          required: (value, c) => (c.field.required && c.field.canModified && c.field.type !== 'MULTIPLE'
            ? required(value) : true),
          maxLength255: maxLength(255),
          typeValidation: (value, c) => {
            if (c.field.type === 'EMAIL' && c.field.canModified) {
              return email(value) && !/[\\|/'"`]/g.test(value);
            }

            if (c.field.type === 'PHONE' && c.field.canModified) {
              return phoneValidator();
            }

            if (c.field.type === 'MULTIPLE' && c.field.canModified) {
              return true;
            }

            if (c.field.type === 'SINGLE' && c.field.canModified) {
              return !!value;
            }

            if (c.field.type === 'TEXT' && c.field.canModified) {
              return !!value;
            }

            if (c.field.name === 'Магазин' || c.field.description === 'Место постоянной регистрации') {
              return true;
            }

            if (c.field.type === 'DATE' && c.field.name === 'Дата рождения') {
              const currentDate = new Date();
              const currentYear = currentDate.getFullYear();
              const birthdayYear = (new Date(value)).getFullYear();
              const diff = currentYear - birthdayYear;
              return diff > 10;
            }

            if (c.field.description.toLowerCase().includes('серия и номер паспорта')
              || c.field.name.toLowerCase().includes('серия и номер паспорта')) {
              const clearValue = value?.replaceAll(' ', '') || '';

              return clearValue.length <= 10 && /[0-9]/g.test(clearValue);
            }

            return !/[\\|/'"`]/g.test(value);
          },
        },
        values: {
          required: (value, c) => (c.field.required && ['MULTIPLE'].includes(c.field.type) && c.field.canModified
            ? required(value)
            : true),
        },
      },
    },
  },
  computed: {
    pdProcessingPolicyFile() {
      return `common.pd-processing-policy-file-name-${this.$domain}`;
    },
    nationalityOptions() {
      return this.nationalityData.map(({ name }) => name);
    },
  },
  async created() {
    const { id: applicationId } = this.$route.params;
    const agreementShouldBeAccepted = this.segmentsRequiringAgreementConfirmation.includes(this.$route.query.segment);

    if (agreementShouldBeAccepted) {
      const { data: { consentDataConfirmed } } = await checkCandidateAgreement(applicationId);

      this.showAgreementModal = !consentDataConfirmed;
    }
  },
  methods: {
    getCurrentReference(fieldId) {
      return this.reference.filter((r) => r.fieldId === fieldId);
    },
    showReference(item) {
      showFile(item.file);
    },
    async removeFile(e, fileId) {
      e.stopPropagation();
      const { filePath } = this.reference.find((r) => r.fileId === fileId);

      if (filePath) {
        this.isLoading = true;
        try {
          const { status } = await removeReference(this.$route.params.id, filePath, this.$route.query.t);
          if (status === 204) {
            this.isLoading = false;
            this.reference = this.reference.filter((r) => r.fileId !== fileId);
            toast.success({ title: this.$t('common.file-remove-success') });
            return true;
          }
          this.isLoading = false;
          toast.danger({ title: this.$t('common.file-remove-error') });
          return false;
        } catch (_) {
          this.isLoading = false;
          toast.danger({ title: this.$t('common.file-remove-error') });
        }
        return false;
      }
      return false;
    },
    async uploadFile(file, fileId, fieldId) {
      const referenceData = new FormData();
      referenceData.append('file', file);
      try {
        const { data, status } = await postReference(this.$route.params.id, referenceData, this.$route.query.t);
        if (status === 200) {
          this.isLoading = false;
          this.reference.push({
            file, fieldId, fileId, filePath: data,
          });
          toast.success({ title: this.$t('common.file-upload-success') });
          return true;
        }
        this.isLoading = false;
        toast.danger({ title: this.$t('common.file-upload-error') });
        return false;
      } catch (e) {
        this.isLoading = false;
        toast.danger({ title: this.$t('common.file-upload-error') });
      }
      return false;
    },
    async uploadFiles() {
      const results = await Promise.all(this.reference.map(async ({ file }) => {
        await this.uploadFile(file);
      }));
      return results.every((r) => r);
    },
    async fileInputHandler(reference, fieldId) {
      if (this.fileUploadError) {
        this.fileUploadError = false;
      }
      const referenceFile = reference[0];
      const filesInField = this.reference.filter((r) => r.fieldId === fieldId);
      const isUniqueFile = this.reference?.length === 0
        || filesInField.every((r) => r.file.name !== reference[0].name);
      if (isUniqueFile) {
        if (this.referenceTypes.includes(referenceFile.type)) {
          const fileId = Math.floor(Math.random() * 999998) + 2;
          this.isLoading = true;
          await this.uploadFile(reference[0], fileId, fieldId);
        }
      } else {
        toast.warning({
          title: this.$t('common.file-already-uploaded'),
        });
      }
    },
    checkData(v) {
      v.$touch();
    },
    async confirmAgreement(closeModal) {
      try {
        const { id: applicationId } = this.$route.params;

        const { status } = await confirmAgreementRequest(applicationId);
        if (status === 200) {
          closeModal();
        } else {
          throw new Error();
        }
      } catch (error) {
        toast.danger({
          title: this.$t('errors.somthing-went-wrong-try-leter'),
        });
      }
    },
    async sendReference() {
      const fields = this.fields.map((item) => {
        if (item.field.type === 'TEXT') {
          return { ...item, value: sanitize(item.value) || null };
        }
        // if (item.field.type === 'FILE') {
        //   return { ...item, filePath: this.reference.map((r) => ({ fileName: r.filePath })) };
        // }
        return item;
      });
      const FormData = {
        application: this.application,
        fields,
        template: this.templateData,
        templateRevision: this.templateRevision,
      };

      const response = await postSecurityData(FormData);

      if (response.status === 200) {
        this.sended = true;
      } else {
        toast.danger({
          title: this.$t('errors.questionnaire-was-not-sent'),
          text: response.data.message,
        });
      }
    },
    async onSend() {
      if (this.reference?.length === 0) {
        this.fileUploadError = true;
      }
      this.$v.$touch();
      if (!this.$v.$invalid) {
        try {
          this.isLoading = true;
          await this.sendReference();
          this.isLoading = false;
        } catch (e) {
          this.isLoading = false;
          toast.danger({
            title: this.$t('errors.questionnaire-was-not-sent'),
            text: '',
          });
        }
      }
    },
    formCurrentDate(date, isBirthday) {
      if (isBirthday) {
        return date ? new Date(date) : new Date('1990-01-01T00:00:00');
      }
      return date ? new Date(date) : new Date('2021-01-01T00:00:00');
    },
  },
};
</script>
<style lang="scss">
  .error-page {
    h1 {
      font-size: 44px;
      margin-bottom: 32px;

      @media screen and (max-width: 768px) {
        font-size: 24px;
        margin-bottom: 16px;
      }
    }

    h3 {
      font-size: 22px;

      @media screen and (max-width: 768px) {
        font-size: 16px;
      }
    }
  }
</style>
